import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { courseEnrollmentsColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { convertDate } from "../../utils/convertDate";
import { digitsThree } from "../../utils/price";
import UserReportsFilter from "./CourseEnrollmentsFilter";
import CourseEnrollmentsPaymentStatusModal from "./sub-components/paymentStatusModal/PaymentStatusModal";

export default function CourseEnrollmentsList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [walletTransactions, setWalletsTransactions] = useState([]);
  const [pagination, setPagination] = useState(null); 

  const { utils } = useSelector(utilsState);

  const getWalletsTransactions = async (params) => {
    const path = "admin/courseEnrollments";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setWalletsTransactions(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  }; 

  useEffect(() => {
    getWalletsTransactions({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    }; 
    getWalletsTransactions(allFilter);
  };

  const data = [];

  walletTransactions?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      name: item?.user?.name,
      mobile: item?.user?.mobile,
      courseName: item?.course?.name,
      id: item._id,
      amount: digitsThree(item?.finalPrice),
      paymentStatus: item.paymentStatus,
      faPaymentStatus: utils?.PAYMENT_STATUS[item.paymentStatus]?.name, 
      date: convertDate(item?.createdAt),
    })
  );

  const paymentStatusRef = useRef();

  const [courseEnrollments, setcourseEnrollments] = useState(null);

  const chnagePaymentStatus = (data) => {
    setcourseEnrollments(data);
    paymentStatusRef.current.showModal();
  };

  return (
    <>  
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={"لیست خرید های دوره "} />
        <CourseEnrollmentsPaymentStatusModal
          reGetData={getWalletsTransactions}
          ref={paymentStatusRef}
          transactionData={courseEnrollments}
        />
        <UserReportsFilter filterDataHandler={filterDataHandler} />
        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
        <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry}
          columns={courseEnrollmentsColumns}
          rows={data}
          onCustomFunction={chnagePaymentStatus}
          customFunctionName="ویرایش وضعیت"
        />

        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
      </div>
    </>
  );
}
